import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import AddIcon from '@material-ui/icons/Add';

import Config from '../../constants/appConfig';
import MaterialIcon from '../../components/MaterialIcon';
import { notification } from 'antd';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  }
});

class Edit extends React.Component {
  state = {
    id: this.props.values?.id || null,
    cnpj: this.props.values?.cnpj || '',
    client: this.props.values?.name_cli || '',
    names: this.props.values?.name_clis.map(it => ({ name: it })) || [],
    name: '',
    showClose: null,
  };

  componentDidMount() {

  };

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    let apiUrl = `${Config.server}/company_link/${this.state.id}`;
    let method = 'PUT';

    let options = {
      method: method,
      body: JSON.stringify({ 'names': this.state.names }),
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json'
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          if (result && result.error) {
            notification.open({
              message: this.props.res[result.message],
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else {
            notification.open({
              message: this.props.res.SUCESSO,
              description: this.props.res.ITEM_ALTERADO,
              icon: <MaterialIcon icon="check_circle" className="text-success" />
            });
            this.props.onClose();
          }
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  addName = () => {
    if (this.state.name.trim() === '') {
      return;
    } else if (this.state.names.some(it => it.name === this.state.name)) {
      this.setState({ name: '' });
      return;
    }
    const newName = {
      name: this.state.name.trim(),
    };
    this.setState(prevState => ({
      names: [...prevState.names, newName],
      name: '',
    }));
  };

  remove = (item) => {
    this.setState(prevState => ({
      names: prevState.names.filter(it => it.name !== item.name),
      showClose: null,
    }));
  };

  render() {
    const { link, res, onClose } = this.props;

    return (
      <div style={{ width: '100%', height: '100%' }} className="form">
        <div className="containerTop">
          <div><h1>{res.COMPARTILHAMENTO}</h1></div>
          <div className="centerTop"></div>
          <div>
            <Button variant="contained" onClick={evemt => { onClose() }} className="popUpButton">
              {res.CANCELAR}
            </Button> &nbsp;
            <Button type="submit" onClick={this.handleSubmit} variant="contained" color="primary" className="popUpButton">
              <SaveIcon className="iconMapS" />
              {res.SALVAR}
            </Button>
          </div>
        </div>
        <div className="form-group notTooBig">
          <TextField
            id="cnpj"
            label={res.CPFCNPJ}
            value={this.state.cnpj}
            className="mb-4 notTooClose"
            size="small"
            fullWidth
            margin="dense"
            InputProps={{
              readOnly: true,
            }}
          />
          <FormControl style={{ width: '100%', marginTop: '1rem' }} className="formControl">
            <InputLabel htmlFor="age-simple">{res.CLIENTE}</InputLabel>
            <Select
              value={this.state.client}
              inputProps={{
                id: 'id_client',
              }}
            >
              <MenuItem key={'0'} value={this.state.client}>{this.state.client}</MenuItem>
            </Select>
          </FormControl>

          <div style={{ marginTop: '1rem', height: 'calc(100vh - 25rem)' }}>
            <div>
              <TextField
                id="name"
                label={res.NOME}
                value={this.state.name}
                onChange={this.handleChange('name')}
                size="small"
                margin="dense"
                style={{ width: '25rem', marginRight: '1rem' }}
                onKeyDown={e => {
                  if (e.keyCode === 13) { this.addName() }
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.toString().slice(0, 45)
                }}
              />
              <div style={{ display: 'inline-block', marginTop: '1.7rem', marginLeft: '0.5rem' }}>
                <Button className={"buttonS buttonMenu"} onClick={event => this.addName()}>
                  <AddIcon />
                </Button>
              </div>
            </div>
            <div style={{ marginTop: '1rem', fontSize: '1.2rem', color: '#999' }}>
              {res.NOMES}
            </div>
            <div style={{ maxHeight: 'calc(100% - 3rem)', marginTop: '1rem' }} onMouseLeave={() => { this.setState({ showClose: null }) }}>
              {this.state.names
                .map(it => (
                  <MenuItem style={{ minHeight: '3rem', borderBottom: 'solid 1px #f1f1f1' }}
                    onMouseOver={() => { this.setState({ showClose: it }) }}
                    className="popup-item">
                    <div style={{ width: '100%', textAlign: 'left' }}>
                      <div style={{ fontWeight: 'bold' }}>{it.name}</div>
                      {this.state.showClose === it &&
                        <div onClick={() => { this.remove(it) }} style={{ position: 'absolute', right: '10px', top: '5px', width: '2rem', height: '2rem', opacity: '.4' }}>
                          <MaterialIcon style={{ margin: '-8px 0 0 -3px' }} icon="close" className="menu_icon" />
                        </div>
                      }
                    </div>
                  </MenuItem>
                ))}
            </div>
            <div style={{ width: '27rem' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

Edit.propTypes = {
  classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(Edit);

const Box = (props) => {
  const { link, res, onClose, values } = props;
  return (
    <div style={{ padding: '2rem' }}>
      <TextFields1 link={link} values={values} res={res} onClose={onClose} />
    </div>)
}

export default Box;

